import request from "../base-request";

export const sendInvite = async (employeeId: string) => {
	const [response] = await request(`/ajax/invite-employee/`, {
		method: "POST",
		body: JSON.stringify({
			employeeId: employeeId,
		}),
	});
	return response;
};
